<template>
  <core-Form ref="form" :model="'form'" :submit="consultaChave">
    <b-row>
      <b-col xl="4" md="5" sm="3">
        <b-form-group label="Chave">
          <b-input
            v-model="form.chave"
            @input="limparConsulta"
            :maxlength="77"
            :readonly="readonly"
            required
          />
        </b-form-group>
      </b-col>

      <b-col xl="2" md="2" sm="3" v-if="consulta.chave">
        <b-form-group label="Tipo Chave">
          <b-form-select
            v-model="consulta.tipoChave"
            disabled
            :options="$api.Arrays.TipoChavePix"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-btn type="submit" v-if="!readonly && !mostrarEscolhaTipoChave" variant="primary">
      Consulta
    </b-btn>

    <div v-if="mostrarEscolhaTipoChave" class="mt-2">
      <span class="d-block mb-2">
        A chave informada pode ser um CPF ou um telefone. Selecione o tipo:
      </span>
      <b-btn variant="primary" class="mr-2" @click="consultarComoCpf">CPF</b-btn>
      <b-btn variant="primary" @click="consultarComoTelefone">Telefone</b-btn>
    </div>

    <br /><br />

    <span v-if="consulta.chave">
      <b-row>
        <b-col xl="4" lg="4" md="4" sm="6" xs="6">
          <b-form-group label="Nome Correntista">
            <b-input v-model="consulta.nomeCorrentista" disabled></b-input>
          </b-form-group>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="6" xs="6">
          <b-form-group label="Tipo Pessoa">
            <b-form-select
              v-model="consulta.tipoPessoa"
              :options="$api.Arrays.TiposPessoa"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="6" xs="6">
          <b-form-group label="Documento Federal">
            <b-input v-model="consulta.documentoFederal" disabled></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="4" lg="4" md="4" sm="6" xs="6">
          <b-form-group label="Conta">
            <b-input v-model="consulta.conta.conta" disabled></b-input>
          </b-form-group>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="6" xs="6">
          <b-form-group label="Tipo Conta">
            <b-form-select
              v-model="consulta.conta.tipoConta"
              :options="$api.Arrays.TiposConta"
              disabled
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="6" xs="6">
          <b-form-group label="Agência">
            <b-input v-model="consulta.conta.agencia" disabled></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="4" lg="4" md="4" sm="6" xs="6">
          <b-form-group label="Nome Instituição Financeira">
            <b-input v-model="consulta.banco.descricao" disabled></b-input>
          </b-form-group>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="6" xs="6">
          <b-form-group label="ISPB Instituição Financeira">
            <b-input v-model="consulta.banco.ispb" disabled></b-input>
          </b-form-group>
        </b-col>
      </b-row>
    </span>
  </core-Form>
</template>

<script>
export default {
  props: {
    rastreada: {
      type: Boolean,
      default: false
    },
    contaDebito: {
      type: Object
    },
    leituraQRCode: {
      type: Object
    },
    wizard: {
      type: Object
    },
    chavePix: {
      type: String
    },
    validarConsulta: {
      type: Boolean,
      default: false
    },
    apenasPixExterno: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    leituraQRCode: function (val) {
      if (val.chave) {
        this.readonly = true
        this.form.chave = val.chave
        this.consultaChave()
      } else {
        this.readonly = false
      }
    },
    chavePix: {
      handler() {
        this.inicializaCampos()
      },
      deep: true
    }
  },
  data() {
    return {
      form: {
        chave: null
      },
      consulta: {},
      readonly: false,
      mostrarEscolhaTipoChave: false
    }
  },
  computed: {
    model: {
      get() {
        var obj = this.value
        return obj
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    validate() {
      let formStatus = this.$api.UI.FormValidate(this.$refs.form)
      if (!formStatus) return formStatus

      if (this.validarConsulta && this.consultaVazia()) {
        this.$api.UI.ShowError(
          'Erro',
          'Obrigatório consultar a chave informada.'
        )
        return false
      }

      if (this.apenasPixExterno && !this.chaveConsultadaExterna()) {
        this.$api.UI.ShowError(
          'Erro',
          'Obrigatório consultar uma chave externa.'
        )
        return false
      }

      if (this.rastreada && !this.consulta.ticket) {
        this.$api.UI.ShowError('Erro', 'Obrigatório gerar ticket de consulta.')
        return false
      } else return formStatus
    },
    consultaVazia() {
      return !this.consulta || Object.keys(this.consulta).length === 0
    },
    limparConsulta() {
      this.consulta = {}
      this.mostrarEscolhaTipoChave = false
    },
    ehCpfValido(chave) {
      return this.$api.UI.Validate.ValidarCPF(chave)
    },
    ehTelefoneValido(chave) {
      return this.$api.UI.Validate.ValidarCelular(chave)
    },
    chaveAmbiguaCpfTelefone(chave) {
      return this.ehCpfValido(chave) && this.ehTelefoneValido(chave)
    },
    consultarComoCpf() {
      this.mostrarEscolhaTipoChave = false
      const chave = this.$api.UI.Format.SomenteNumeros(this.form.chave)
      this.form.chave = chave
      this.executarConsultaChave(chave)
    },
    consultarComoTelefone() {
      this.mostrarEscolhaTipoChave = false
      let numeros = this.$api.UI.Format.SomenteNumeros(this.form.chave)
      if (numeros.length > 11 && numeros.startsWith('55')) {
        numeros = numeros.substring(2)
      }
      const chave = '+55' + numeros
      this.form.chave = chave
      this.executarConsultaChave(chave)
    },
    inicializaCampos() {
      this.form.chave = this.chavePix
    },
    inicializarChave(chave) {
      this.form.chave = chave
    },
    consultaChave() {
      if (this.chaveAmbiguaCpfTelefone(this.form.chave)) {
        this.mostrarEscolhaTipoChave = true
        return
      }

      this.executarConsultaChave(this.form.chave)
    },
    executarConsultaChave(chave) {
      let th = this
      if (this.rastreada) {
        let dto = {
          Chave: chave,
          Agencia: this.contaDebito.agencia.numero,
          AgenciaDigito: this.contaDebito.agencia.digito,
          Conta: this.contaDebito.conta.numero,
          ContaDigito: this.contaDebito.conta.digito,
          ContaPgto: this.contaDebito.conta.contaPgto,
          TipoConta: parseInt(this.contaDebito.conta.tipoConta),
          CodigoLeituraQRCode:
            (this.leituraQRCode && this.leituraQRCode.codigoLeituraQRCode) ||
            (this.leituraQRCode && this.leituraQRCode.CodigoLeituraQRCode) ||
            null
        }

        this.$api.ContaChavePix.ConsultaRastreada(dto).then(response => {
          if (response) {
            if (response.status && response.status === 404) {
              th.$api.UI.ShowError('Erro', 'Chave não encontrada.')
            } else if (response && response.sucesso === false) {
              th.$api.UI.ShowError('Erro', response.mensagem)
            } else if (th.$api.UI.PostAction(response)) {
              th.consulta = response
              th.consulta.documentoFederal = th.$api.UI.Format.DocumentoFederal(
                response.documentoFederal
              )
              th.model = Object.assign({}, response)
              if (this.wizard != null) {
                this.wizard.nextTab()
              }
            }
          }
        })
      } else {
        let dto = {
          Chave: chave,
          Agencia: this.contaDebito.agencia.numero,
          AgenciaDigito: this.contaDebito.agencia.digito,
          Conta: this.contaDebito.conta.numero,
          ContaDigito: this.contaDebito.conta.digito,
          ContaPgto: this.contaDebito.conta.contaPgto,
          TipoConta: parseInt(this.contaDebito.conta.tipoConta)
        }
        this.$api.ContaChavePix.ConsultaChaveOnline(dto).then(response => {
          if (response.status && response.status === 404) {
            th.$api.UI.ShowError('Erro', 'Chave não encontrada.')
          } else if (response && response.sucesso === false) {
            th.$api.UI.ShowError('Erro', response.mensagem)
          } else if (th.$api.UI.PostAction(response)) {
            th.consulta = response
            th.consulta.documentoFederal = th.$api.UI.Format.DocumentoFederal(
              response.documentoFederal
            )
            th.model = Object.assign({}, response)
          }
        })
      }
    },
    chaveConsultadaExterna() {
      return this.consulta.banco ? this.consulta.banco.ispb != process.env.VUE_APP_ISPB : false
    }
  },
  mounted() {
    this.inicializaCampos()
  }
}
</script>